import { Button, Col, Image, Row } from 'antd'
import {
  camelCase,
  compact,
  get,
  find,
  includes,
  isEmpty,
  orderBy,
  pick,
  startCase,
  size,
} from 'lodash'
import Checkpoints from '../Checkpoints/Checkpoints'
import ReportMeasurement from '../ReportMeasurement/ReportMeasurement'
import './ReportSectionPage.style.less'
import cx from 'classnames'
import {
  inviteReviewerPermissionFN,
  isEmptyValue,
  removeListPrefix,
} from '@/utils/common'
import DrawerSection from '../DrawerSection/DrawerSection'
import { useState } from 'react'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import DrawerDefect from '../DrawerDefect/DrawerDefect'
import DrawerPhotoComment from '../DrawerPhotoComment/DrawerPhotoComment'
import InspectionReportDrawer from '@/components/InspectionReportDrawer'
import {
  InspectionReportSectionEnum,
  InspectionStatus,
  InspectionTemplateType,
  MEASUREMENT_SPECIAL_SEPARATOR_KEY,
  SECTION_TYPE_MEASUREMENT_SECTION,
} from '@/constant/qsf'
import ChatButton from '@/components/ChatButton/ChatButton'
import { eventBus } from '@/utils/eventBus'
import { MITT_EVENT_BUS } from '@/constant/common'

const { INSPECTION_REPORT_COMMENT } = MITT_EVENT_BUS
const { UNDER_REVIEW, NEEDS_REVISIONS } = InspectionStatus

import { SECTION_NAMES, SUBSECTION_NAMES } from '@/constant/common'

interface Props {
  data: any
  editable: boolean
  user: any
  templateSections: Array<any>
  dataInspection?: any
  reportType: string
  extraSource?: any
  isDefectStatusEnabled?: boolean
}

type DataMedia = {
  media: string
  comment: string
}

type DataType = {
  values?: [DataMedia]
  id: string
  title: string
  name: string
}
const defaultDataSet = {
  value: [],
  id: '',
  title: '',
  name: '',
}

function ReportSectionPage(props: Props) {
  const {
    data,
    reportType,
    extraSource = {},
    templateSections = [],
    isDefectStatusEnabled = false,
  } = props

  const { GDS_FABRIC, FCCA } = InspectionTemplateType
  const isInvitedAsReviewer = inviteReviewerPermissionFN(
    props.user,
    props.dataInspection
  )
  const [drawer, setdrawer] = useState(false)
  const [showCheckpointDrawer, setShowCheckpointDrawer] = useState(false)
  const [checkpointDataSelected, setCheckpointDataSelected] = useState(null)
  const [subSectionDataSelected, setSubSectionDataSelected] = useState(null)
  const [selectedSection, setselectedSection] = useState(null)
  const [selectedIndex, setselectedIndex] = useState(null)
  const [isEditPhoto, setIsEditPhoto] = useState(null)

  const [drawerDefect, setdrawerDefect] = useState(false)
  const [selectedDefect, setselectedDefect] = useState(null)

  const [selectedCheckPoint, setSelectedCheckPoint] =
    useState<DataType>(defaultDataSet)

  const [drawerPhoto, setdrawerPhoto] = useState(false)

  const [photoIndex, setphotoIndex] = useState(-1)
  const [drawerSelectType, setDrawerSelectType] =
    useState<InspectionReportSectionEnum | null>(null)

  const inspectionRound = get(props.dataInspection, 'round')
  const inspectionStatus = get(props.dataInspection, 'status')

  const onEdit = (index, data: any) => {
    setdrawer(true)
    setselectedSection(data)
    setselectedIndex(index)
  }

  const onEditCheckpoint = (dataCheckpoint) => {
    const {
      sectionPoint = '',
      checkpoint,
      subSection: subSectionTemplate,
      entryIndex = null,
      photoSelected = null,
      addNewPhotoKey = '',
      checkpointKey = '',
    } = dataCheckpoint

    setShowCheckpointDrawer(true)
    setCheckpointDataSelected({
      ...checkpoint,
      entryIndex,
      photoSelected,
      addNewPhotoKey,
      checkpointKey,
    })
    setSubSectionDataSelected({ ...subSectionTemplate, sectionPoint })
  }

  const onEditDefect = (index, data: any) => {
    setdrawerDefect(true)
    setselectedIndex(index)
    setselectedDefect(data)
  }

  const onEditPhoto = (index, data, photoIndex, isEditPhoto) => {
    const transformData = transformDataSet(data)

    setdrawerPhoto(true)
    setselectedIndex(index)
    setSelectedCheckPoint(transformData)
    setphotoIndex(photoIndex)
    setIsEditPhoto(isEditPhoto)
  }

  const onCloseInspectionReportDrawerFN = (value) => {
    setCheckpointDataSelected(null)
    setShowCheckpointDrawer(value)
  }

  const transformDataSet = (data) => {
    const pickItem = pick(data, ['photos', 'value'])
    const result = {
      id: data.id,
      title: data.title,
      code: data.code || null,
      name: data.name,
      values: pickItem['photos'] || pickItem['value'],
    }

    return result
  }

  const onAddPhoto = (index, data, photoIndex, isEditPhoto) => {
    const transformData = transformDataSet(data)

    setdrawerPhoto(true)
    setselectedIndex(index)
    setSelectedCheckPoint(transformData)
    setphotoIndex(photoIndex)
    setIsEditPhoto(isEditPhoto)
  }

  const resultColor = (result) => {
    return result === 'PASS'
      ? '#65bf73'
      : result === 'FAIL'
      ? '#C03261'
      : result === 'PENDING'
      ? '#EF9747'
      : '#848484'
  }

  const onOpenCommentDrawer = (
    section,
    sectionIndex,
    subSection,
    subSectionIndex
  ) => {
    eventBus.emit(INSPECTION_REPORT_COMMENT, {
      selectedSubSection: subSection ? { subSection, subSectionIndex } : null,
      selectedSection: { section, sectionIndex },
    })
  }

  const showName = (item) => {
    if (!isEmptyValue(item?.title)) {
      return removeListPrefix(item?.title)
    }
    return startCase(camelCase(item?.name))
  }

  const findSubSectionTemplateByName = (sectionName, subSectionName) => {
    return props.templateSections
      ?.find((section) => section?.name === sectionName)
      ?.sub_sections?.find((subSection) => subSection?.name === subSectionName)
  }

  const renderCommentsSection = ({ section, sectionIndex }) => {
    let resultContent = null
    const isNewSectionRound = get(section, 'round') === inspectionRound
    const sectionCommentCounter = get(section, 'comment_counter')

    if (includes([UNDER_REVIEW, NEEDS_REVISIONS], inspectionStatus)) {
      if (isInvitedAsReviewer) {
        resultContent = (
          <ChatButton
            isHidden={extraSource?.generatingReportAtom?.isGenerating}
            chatCount={sectionCommentCounter}
            redPoint={isNewSectionRound}
            onClick={() =>
              onOpenCommentDrawer(section, sectionIndex, null, null)
            }
          />
        )
      }
    }

    return resultContent
  }

  const renderCommentSubSection = ({
    section,
    sectionIndex,
    subSection,
    subSectionIndex,
  }) => {
    let resultContent = null

    const isNewSubSectionRound = get(subSection, 'round') === inspectionRound
    const subSectionCommentCounter = get(subSection, 'comment_counter')
    if (includes([UNDER_REVIEW, NEEDS_REVISIONS], inspectionStatus)) {
      if (isInvitedAsReviewer) {
        resultContent = (
          <ChatButton
            isHidden={extraSource?.generatingReportAtom?.isGenerating}
            redPoint={isNewSubSectionRound}
            chatCount={subSectionCommentCounter}
            onClick={() =>
              onOpenCommentDrawer(
                section,
                sectionIndex,
                subSection,
                subSectionIndex
              )
            }
          />
        )
      }
    }

    return resultContent
  }

  const handleRenderingDefects = (section, key) => {
    const { defects = [], title } = section

    if (isEmpty(defects)) {
      return null
    }
    const renderDefectsPhotos = (itemDefect) => {
      const { photos = [] } = itemDefect

      const photoItem = photos.map((media, photoKey) => {
        return (
          <Col
            className={cx(
              'defect-image',
              photos.length > 1 ? 'flex-49-percent' : ''
            )}
            span={photos.length > 1 ? 12 : 24}
            key={photoKey}
          >
            <Image
              // TODO: Use thumbnail instead
              // src={media.thumbnail}
              src={media.media}
              preview={{
                src: media.media,
              }}
              style={{ objectFit: 'contain' }}
            />
            <Row>
              <p>{media.comment}</p>
              {props.editable && (
                <Button
                  className="edit-button"
                  onClick={() => {
                    setDrawerSelectType(InspectionReportSectionEnum.DEFECT)
                    onEditPhoto(
                      `${key + 1}.${
                        section?.subSections?.length ??
                        section?.value?.length + 1
                      } ${startCase(camelCase(section.name))} Defects`,
                      itemDefect,
                      photoKey,
                      true
                    )
                  }}
                  icon={<EditOutlined />}
                />
              )}
            </Row>
          </Col>
        )
      })
      return <Row justify={'space-between'}>{photoItem}</Row>
    }

    return (
      <div className="report-defect-container">
        <p className="defect-title">
          {section?.subSections?.length ?? section?.value?.length + 1}{' '}
          {section?.title ?? startCase(camelCase(section?.name))} Defects
        </p>
        <Row justify={'space-between'}>
          {section.defects.map((defect, index) => {
            const defectName = compact([
              defect?.code,
              defect.name,
              defect.defect_area,
            ]).join(' - ')
            return (
              <Col
                key={index}
                span={defect?.photos.length > 1 ? 24 : 12}
                className={cx(
                  'defect-container',
                  defect?.photos.length === 1 ? 'flex-49-percent' : '',
                  defect.photos.length < 3 ? 'page-break-inside' : ''
                )}
              >
                <Row justify={'space-between'}>
                  <Col>
                    <p className="label">{defectName}</p>
                    <p className="label" style={{ color: '#C03261' }}>
                      {defect.classification}
                    </p>
                    <p className="label">
                      Qty: {defect.quantity} - {defect.item}
                    </p>
                    {isDefectStatusEnabled &&
                      (!isEmptyValue(defect?.option?.defect_status?.status) ||
                        !isEmptyValue(defect?.defect_status)) && (
                        <p className="label">
                          Defect Status:{' '}
                          {defect?.option?.defect_status?.status ||
                            defect?.defect_status}
                        </p>
                      )}
                    {isDefectStatusEnabled &&
                      !isEmptyValue(
                        defect?.option?.defect_status?.approved
                      ) && (
                        <p className="label">
                          Approved: {defect?.option?.defect_status?.approved}
                        </p>
                      )}
                  </Col>
                  {props.editable && (
                    <Button
                      className="edit-button"
                      onClick={() =>
                        onEditDefect(
                          `${key + 1}.${
                            section?.subSections?.length ??
                            section?.value?.length + 1
                          } ${startCase(camelCase(section.name))} Defects`,
                          defect
                        )
                      }
                      icon={<EditOutlined />}
                    />
                  )}
                </Row>

                {renderDefectsPhotos(defect)}

                {props.editable && (
                  <Button
                    className="add-photo-button"
                    onClick={() => {
                      setDrawerSelectType(InspectionReportSectionEnum.DEFECT)
                      onAddPhoto(
                        `${key + 1}.${1} ${startCase(
                          camelCase(title)
                        )}: Defects`,
                        defect,
                        0,
                        false
                      )
                    }}
                    icon={<PlusOutlined />}
                  >
                    Add Photo
                  </Button>
                )}
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
  const renderSectionScore = (section) => {
    const isFCCA = [FCCA].includes(props.dataInspection?.template?.report_type)
    const isGroupStatusTrue = templateSections?.find(
      (ts) => ts.name === section.name
    )?.options?.group?.status

    if (!isFCCA || !isGroupStatusTrue) return null

    const score = section?.option?.score ?? 0
    const weight = section?.option?.weight ?? 0
    const percentage = section?.option?.percentage ?? 0

    return (
      <Col span={24}>
        <div className="section-score-container page-break-inside">
          <Row style={{ width: '100%' }}>
            <Col span={12}>
              <p className="label">Score (of Weight) / %</p>
            </Col>
            <Col span={12}>
              <p className="value">
                {score} (of {weight}) / {percentage}%
              </p>
            </Col>
          </Row>
        </div>
      </Col>
    )
  }

  const processStretchabilityCheckpoints = (
    checkpoints,
    sectionName,
    subSectionName
  ) => {
    const formatNumber = (num) => {
      if (isNaN(num)) return errorMessage
      if (Number.isInteger(num)) return num.toString()
      return parseFloat(num.toFixed(2)).toString()
    }
    const errorMessage = 'Error'
    const isStretchabilitySection =
      sectionName !== SECTION_NAMES.STRETCHABILITYCHECK ||
      subSectionName !== SUBSECTION_NAMES.STRETCHABILITY

    if (isStretchabilitySection || !includes([GDS_FABRIC], reportType)) {
      return checkpoints
    }

    const requiredLengthData = find(checkpoints, { name: 'requiredLength' })
    const foundLengthData = find(checkpoints, { name: 'foundLength' })
    const requiredWidthData = find(checkpoints, { name: 'requiredWidth' })
    const foundWidthData = find(checkpoints, { name: 'foundWidth' })

    if (
      !requiredLengthData ||
      !foundLengthData ||
      !requiredWidthData ||
      !foundWidthData
    ) {
      return checkpoints
    }
    const extractNumberAndUnit = (value) => {
      if (isEmptyValue(value)) return { number: null, unit: '' }
      const match = value.match(/^(\d*\.?\d*)\s*(\D+)?$/)
      if (!match) return { number: null, unit: '' }
      const number = parseFloat(match[1])
      const unit = match[2] || ''
      return { number: isNaN(number) ? null : number, unit }
    }

    const requiredLength = extractNumberAndUnit(requiredLengthData?.value)
    const foundLength = extractNumberAndUnit(foundLengthData?.value)
    const requiredWidth = extractNumberAndUnit(requiredWidthData?.value)
    const foundWidth = extractNumberAndUnit(foundWidthData?.value)

    const isValidLength =
      requiredLength.number !== null && foundLength.number !== null
    const isValidWidth =
      requiredWidth.number !== null && foundWidth.number !== null

    let lengthDiscrepancy = 0
    let lengthDiscrepancyPercent = 0
    let widthDiscrepancy = 0
    let widthDiscrepancyPercent = 0

    if (isValidLength) {
      const requiredLengthValue = requiredLength.number
      const foundLengthValue = foundLength.number
      lengthDiscrepancy = foundLengthValue - requiredLengthValue
      if (requiredLengthValue !== 0) {
        lengthDiscrepancyPercent =
          (lengthDiscrepancy / requiredLengthValue) * 100
      }
    }

    if (isValidWidth) {
      const requiredWidthValue = requiredWidth.number
      const foundWidthValue = foundWidth.number
      widthDiscrepancy = foundWidthValue - requiredWidthValue
      if (requiredWidthValue !== 0) {
        widthDiscrepancyPercent = (widthDiscrepancy / requiredWidthValue) * 100
      }
    }

    const calculatedFields = [
      {
        id: `calc-lengthDiscrepancy-${foundLengthData.id}`,
        name: 'lengthDiscrepancy',
        title: 'Length Discrepancy',
        value: isValidLength
          ? formatNumber(lengthDiscrepancy) + requiredLength.unit
          : errorMessage,
        control_type: 'text',
        display_order: foundLengthData.display_order + 0.1,
      },
      {
        id: `calc-lengthDiscrepancyPercent-${foundLengthData.id}`,
        name: 'lengthDiscrepancyPercent',
        title: 'Length Discrepancy %',
        value:
          isValidLength && requiredLength.number !== 0
            ? formatNumber(lengthDiscrepancyPercent) + '%'
            : errorMessage,
        control_type: 'text',
        display_order: foundLengthData.display_order + 0.2,
      },
      {
        id: `calc-widthDiscrepancy-${foundWidthData.id}`,
        name: 'widthDiscrepancy',
        title: 'Width Discrepancy',
        value: isValidWidth
          ? formatNumber(widthDiscrepancy) + requiredWidth.unit
          : errorMessage,
        control_type: 'text',
        display_order: foundWidthData.display_order + 0.1,
      },
      {
        id: `calc-widthDiscrepancyPercent-${foundWidthData.id}`,
        name: 'widthDiscrepancyPercent',
        title: 'Width Discrepancy %',
        value:
          isValidWidth && requiredWidth.number !== 0
            ? formatNumber(widthDiscrepancyPercent) + '%'
            : errorMessage,
        control_type: 'text',
        display_order: foundWidthData.display_order + 0.2,
      },
    ]

    const modifiedCheckpoints = orderBy(
      [...checkpoints, ...calculatedFields],
      'display_order'
    )
    return modifiedCheckpoints
  }

  const processSubSectionCheckpoints = (
    checkpoints,
    section,
    subSection,
    subSectionTemplate
  ) => {
    const stretchCheckpoints = processStretchabilityCheckpoints(
      checkpoints,
      section.name,
      subSection.name
    )

    const { score, weight } = subSection?.option || {}
    const isFCCA = props.dataInspection?.template?.report_type === FCCA

    let checkpointsWithScore = stretchCheckpoints

    if (isFCCA && size(subSection?.option)) {
      const findingCP = find(stretchCheckpoints, { name: 'finding' })
      const scoreCP = {
        id: `score-weight-${subSection.id}`,
        name: 'score_of_weight',
        title: 'Score (of Weight)',
        value: `${score ?? 0} (of ${weight ?? 0})`,
        control_type: 'text',
        display_order: (findingCP?.display_order ?? 0) + 0.1,
        uneditable: true,
      }
      checkpointsWithScore = orderBy(
        [...stretchCheckpoints, scoreCP],
        'display_order'
      )
    }

    const visibleCheckpoints = checkpointsWithScore.filter((cp: any) => {
      const templateCp = subSectionTemplate?.checkpoints?.find(
        (t: any) => t.name === cp.name
      )
      return !cp?.options?.hidden && !templateCp?.options?.hidden
    })

    return visibleCheckpoints
  }

  return (
    <div className="section-container">
      {orderBy(
        data.map((section, sectionIndex) => {
          const { section_type } = section

          return (
            <div key={sectionIndex} className="section" id={section?.id}>
              <div>
                <div className="title-container">
                  <p className="title">
                    {sectionIndex + 1}. {showName(section)}
                  </p>
                  <Row className="result-container">
                    <p
                      className="result"
                      style={{
                        color: resultColor(section?.result),
                      }}
                    >
                      {section.result}
                    </p>
                    {renderCommentsSection({ section, sectionIndex })}
                    {props.editable && (
                      <Button
                        className="edit-button"
                        onClick={() => onEdit(`${sectionIndex + 1}.`, section)}
                        icon={<EditOutlined />}
                      />
                    )}
                  </Row>
                </div>
                {renderSectionScore(section)}

                <p className="comment">{section.comment}</p>
              </div>
              {section?.subSections?.map((subSection, subSectionIndex) => {
                const sectionPoint = `${sectionIndex + 1}.${
                  subSectionIndex + 1
                }`
                const showSubName = showName(subSection)

                if (includes([SECTION_TYPE_MEASUREMENT_SECTION], section_type))
                  return null

                const subSectionTemplate = findSubSectionTemplateByName(
                  section?.name,
                  subSection?.name
                )

                const modifiedCheckpoints = processSubSectionCheckpoints(
                  subSection.checkpoints,
                  section,
                  subSection,
                  subSectionTemplate
                )
                return (
                  <div
                    key={subSectionIndex}
                    className="report-sub-section-container"
                    id={subSection?.id}
                  >
                    <div>
                      <div className="sub-section-title-container">
                        <p className="sub-section-title">
                          {`${sectionPoint} ${showSubName}`}
                        </p>
                        <Row>
                          <p
                            className="result"
                            style={{
                              color: resultColor(subSection.result),
                            }}
                          >
                            {/* {`${sectionPoint} ${showSubName}`} */}
                            {subSection.result}
                          </p>
                          {renderCommentSubSection({
                            section,
                            sectionIndex,
                            subSection,
                            subSectionIndex,
                          })}

                          {props.editable && (
                            <Button
                              className="edit-button"
                              onClick={() => onEdit(sectionPoint, subSection)}
                              icon={<EditOutlined />}
                            />
                          )}
                        </Row>
                      </div>
                      <p className="comment">{subSection.comment}</p>
                    </div>
                    <Row
                      justify={'space-between'}
                      style={{ flexFlow: 'column' }}
                      // className="report-page-break"
                    >
                      {modifiedCheckpoints.map((checkpoint, cpKey) => {
                        const { generatingReportAtom, inspectionCommentsData } =
                          extraSource
                        const subSectionTemplate = findSubSectionTemplateByName(
                          section?.name,
                          subSection?.name
                        )

                        return (
                          <div
                            key={cpKey}
                            className="report-checkpoint-container"
                          >
                            <Checkpoints
                              options={{
                                inspectionRound,
                                inspectionStatus,
                                checkpointIndex: cpKey,
                                isInvitedAsReviewer,
                                generatingReportAtom,
                                inspectionCommentsData,
                              }}
                              checkpoint={checkpoint}
                              section={{ section, sectionIndex }}
                              subSection={{ subSection, subSectionIndex }}
                              user={props.user}
                              key={cpKey}
                              data={checkpoint}
                              editable={props.editable}
                              subSectionTemplate={findSubSectionTemplateByName(
                                section?.name,
                                subSection?.name
                              )}
                              reportType={reportType}
                              templateSections={props.templateSections}
                              sectionName={section.name}
                              subsectionName={subSection.name}
                              onEditPhoto={(photoIndex) => {
                                setDrawerSelectType(
                                  InspectionReportSectionEnum.CHECKPOINT
                                )
                                onEditPhoto(
                                  `${sectionIndex + 1}.${subSectionIndex + 1}
                              ${startCase(camelCase(subSection.name))}`,
                                  checkpoint,
                                  photoIndex,
                                  true
                                )
                              }}
                              onAddPhoto={() => {
                                setDrawerSelectType(
                                  InspectionReportSectionEnum.CHECKPOINT
                                )
                                onAddPhoto(
                                  `${sectionIndex + 1}.${subSectionIndex + 1}
                              ${startCase(camelCase(subSection.name))}`,
                                  checkpoint,
                                  0,
                                  false
                                )
                              }}
                              editComponent={(propsEdit?: any) =>
                                props.editable && !checkpoint.uneditable ? (
                                  <Button
                                    type="text"
                                    className="edit-button-checkpoint"
                                    onClick={() =>
                                      onEditCheckpoint({
                                        sectionPoint,
                                        index: cpKey,
                                        checkpoint,
                                        subSection: subSectionTemplate,
                                        ...propsEdit,
                                      })
                                    }
                                    icon={<EditOutlined />}
                                  />
                                ) : (
                                  <></>
                                )
                              }
                              addNewPhotoButton={(propsEdit?: any) =>
                                props.editable ? (
                                  <Button
                                    type="text"
                                    className="add-photo-button"
                                    onClick={() =>
                                      onEditCheckpoint({
                                        sectionPoint,
                                        index: cpKey,
                                        checkpoint,
                                        subSection: subSectionTemplate,
                                        ...propsEdit,
                                      })
                                    }
                                    icon={<PlusOutlined />}
                                  >
                                    Add Photo
                                  </Button>
                                ) : (
                                  <></>
                                )
                              }
                            />
                          </div>
                        )
                      })}
                    </Row>
                  </div>
                )
              })}
              {section.section_type === SECTION_TYPE_MEASUREMENT_SECTION &&
                section.value?.map((measurement, mKey) => {
                  const { name = '' } = measurement
                  const displayName = name.replace(
                    MEASUREMENT_SPECIAL_SEPARATOR_KEY,
                    '-'
                  )

                  const matchingSubSection = section.subSections?.find(
                    (sub: any) => sub.name === name
                  )
                  const checkpointValue =
                    matchingSubSection?.checkpoints?.[0]?.value
                  const sampleSize = checkpointValue?.sampleSize || undefined

                  return (
                    <div
                      key={mKey}
                      className="report-sub-section-container"
                      id={measurement?.id}
                    >
                      <div className="sub-section-title-container">
                        <Row align={'middle'}>
                          <p
                            className="sub-section-title"
                            style={{ marginTop: 15 }}
                          >
                            {sectionIndex + 1}.{mKey + 1}&nbsp;
                            {measurement.color + ' ' + measurement.size}
                          </p>
                        </Row>
                        <Row>
                          <p
                            className="result"
                            style={{
                              color: resultColor(measurement.result),
                            }}
                          >
                            {measurement.result}
                          </p>
                          {props.editable && (
                            <Button
                              className="edit-button"
                              onClick={() =>
                                onEdit(
                                  ` ${sectionIndex + 1}.${mKey + 1}.`,
                                  measurement
                                )
                              }
                              icon={<EditOutlined />}
                            />
                          )}
                        </Row>
                      </div>
                      <p className="comment">{measurement.comment}</p>
                      <ReportMeasurement
                        measurementUnit={section?.measurementUnit}
                        data={measurement.data}
                        sampleSize={sampleSize}
                      />
                    </div>
                  )
                })}
              {handleRenderingDefects(section, sectionIndex)}
            </div>
          )
        })
      )}

      {props.editable && (
        <DrawerSection
          onClose={() => setdrawer(false)}
          data={selectedSection}
          open={drawer}
          index={selectedIndex}
        />
      )}
      {props.editable && (
        // TODO: Update checkpoint Drawer
        <InspectionReportDrawer
          onClose={onCloseInspectionReportDrawerFN}
          dataSource={subSectionDataSelected}
          data={checkpointDataSelected}
          open={showCheckpointDrawer}
          index={selectedIndex}
        />
      )}
      {props.editable && (
        <DrawerDefect
          onClose={() => setdrawerDefect(false)}
          data={selectedDefect}
          open={drawerDefect}
          index={selectedIndex}
          dataInspection={props.dataInspection}
        />
      )}

      {props.editable && (
        <DrawerPhotoComment
          onClose={() => setdrawerPhoto(false)}
          data={selectedCheckPoint}
          open={drawerPhoto}
          photoIndex={photoIndex}
          index={selectedIndex}
          isEditPhoto={isEditPhoto}
          type={drawerSelectType}
        />
      )}
    </div>
  )
}

export default ReportSectionPage
